const DEFAULT_REQUEST_TIMEOUT = 10;
const DEFAULT_CONNECTION_TIMEOUT = 10;
const DEFAULT_STATS_REQUEST_TIMEOUT = 10;
const DEFAULT_EXPORT_TIMEOUT = 10;

export const HEALTH_MONITOR_BASE_URL = process.env.REACT_APP_HEALTH_MONITOR_BASE_URL as string;

export const AGMS_SERVER = process.env.REACT_APP_AGMS_SERVER as string;
export const AGMS_BASE_URL = process.env.REACT_APP_AGMS_BASE_URL as string;
export const SCREENSHOTS_URL = process.env.REACT_APP_SCREENSHOTS_URL as string;

export const IS_CLEAN_LAYOUT = String(process.env.REACT_APP_IS_CLEAN_LAYOUT).toLowerCase() === 'true';

export const REQUST_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT || `${DEFAULT_REQUEST_TIMEOUT}`) * 1000;

export const CONNECTION_TIMEOUT =
  parseInt(process.env.REACT_APP_CONNECTION_TIMEOUT || `${DEFAULT_CONNECTION_TIMEOUT}`) * 1000;

export const STATS_REQUST_TIMEOUT =
  parseInt(process.env.REACT_APP_STATS_API_TIMEOUT || `${DEFAULT_STATS_REQUEST_TIMEOUT}`) * 1000;

export const EXPORT_TIMEOUT =
  parseInt(process.env.REACT_APP_EXPORT_EXCEL_TIMEOUT || `${DEFAULT_EXPORT_TIMEOUT}`) * 1000;

export const USE_LOGGER = Boolean(process.env.USE_LOGGER || 'false');

// ---------------------------------------------------------
// OIDC / OAuth2 PKCE configuration
// ---------------------------------------------------------
export const OIDC_AUTHORITY = process.env.REACT_APP_OIDC_AUTHORITY as string;
export const OIDC_CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID as string;
export const OIDC_SCOPE = (process.env.REACT_APP_OIDC_SCOPE as string) || 'openid';
export const OIDC_REDIRECT_PATH = (process.env.REACT_APP_OIDC_REDIRECT_PATH as string) || '/auth/callback';
export const OIDC_POST_LOGOUT_PATH = (process.env.REACT_APP_OIDC_POST_LOGOUT_PATH as string) || '/';

export const getOidcRedirectUri = (): string => `${window.location.origin}${OIDC_REDIRECT_PATH}`;

export const getOidcPostLogoutRedirectUri = (): string => `${window.location.origin}${OIDC_POST_LOGOUT_PATH}`;
